import React, { useMemo } from 'react';

import { CartItem, Address } from '../../types';
import BusinessItemsPaper from './BusinessItemsPaper';
// import { createUseStyles } from 'react-jss';

export interface CartItemsProps {
  cart: CartItem[];
  addresses: Address[];
  selectedAddress: number;
  editable: boolean
}

const CartItems: React.FC<CartItemsProps> = ({
  cart,
  addresses,
  selectedAddress,
  editable
}) => {
  // const classes = useStyles();
  const errorArray: boolean[] = []
  const itemsPerBusiness = useMemo(() => {
    const ret: Record<string, CartItem[]> = {};
    cart.forEach((item) => {
      const businessID = item.product.business.id;
      if (!Array.isArray(ret[businessID])) {
        ret[businessID] = [];
        errorArray.push(false)
      }
      ret[businessID].push(item);
    });
    return ret;
  }, [cart]);


  return (
    <div>
      {Object.keys(itemsPerBusiness).map((key, index) => {
        const business = itemsPerBusiness[key][0].product.business;
        return (
          <div key={business.id} className="mb-5">
            <BusinessItemsPaper
              index={index}
              business={business}
              editable={editable}
              addresses={addresses}
              items={itemsPerBusiness[key]}
              selectedAddress={selectedAddress}
            />
          </div>
        );
      })}
    </div>
  );
};

// const useStyles = createUseStyles({
//   wrapper: {
//     '&:not(first-child)': {
//       marginB
//     }
//   }
// });

export default CartItems;
